import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    allowProps: true,
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#292d33',
                secondary: '#18417D',
                accent: '#fff',
                accent2: '#292d33',
                rowQuestion: '#ccc',
                rowReply: '#d2d2d2',
                rowDivider: '#c4c4c4',
                error: '#F4511E',
                warning: '#ff9800',
                info: '#3b65a5',
                success: '#66bb6a',
            },
        },
    },
});
